import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../../api';

const TYPE_BADGE = {
  support:  'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  feedback: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
};

export default function AdminSupport() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setMessages(await api.get('/admin/support-messages'));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return (
    <div className="flex items-center justify-center h-64">
      <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (error) return <div className="p-8 text-sm text-red-600">{error}</div>;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500 dark:text-slate-400">{messages.length} submission{messages.length !== 1 ? 's' : ''}</p>
        <button onClick={load} className="text-xs text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">Refresh</button>
      </div>

      {messages.length === 0 ? (
        <div className="card p-8 text-center text-sm text-slate-400">No support or feedback submissions yet.</div>
      ) : (
        <div className="space-y-2">
          {messages.map(m => (
            <div key={m.id} className="card p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full capitalize ${TYPE_BADGE[m.type] || ''}`}>{m.type}</span>
                <span className="text-xs text-slate-500 dark:text-slate-400">{m.user_email}</span>
                {m.account_name && <span className="text-xs text-slate-400">· {m.account_name}</span>}
                <span className="flex-1" />
                <span className="text-xs text-slate-400">{new Date(m.created_at).toLocaleString()}</span>
              </div>
              <p className="text-sm text-slate-700 dark:text-slate-300 whitespace-pre-wrap">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
